/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceMobileRotated = createReactComponent(
  "device-mobile-rotated",
  "IconDeviceMobileRotated",
  [
    [
      "path",
      {
        d: "M3 6m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M20 11v2", key: "svg-1" }],
    ["path", { d: "M7 12h-.01", key: "svg-2" }]
  ]
);

export { IconDeviceMobileRotated as default };
//# sourceMappingURL=IconDeviceMobileRotated.js.map
